// Názvy původních hodnot lokality (slug) ze statického selectu.
// Používá se jen pro předvyplnění formulářů u záznamů uložených před zavedením našeptávače.

export const LEGACY_LOCATION_LABELS = {
    praha: "Praha",
    brno: "Brno",
    ostrava: "Ostrava",
    stredocesky: "Středočeský kraj",
    jihocesky: "Jihočeský kraj",
    plzensky: "Plzeňský kraj",
    karlovarsky: "Karlovarský kraj",
    ustecky: "Ústecký kraj",
    liberecky: "Liberecký kraj",
    kralovehradecky: "Královéhradecký kraj",
    vysocina: "Vysočina",
    jihomoravsky: "Jihomoravský kraj",
    olomoucky: "Olomoucký kraj",
    zlinsky: "Zlínský kraj",
    moravskoslezsky: "Moravskoslezský kraj",
};

// Sestavení objektu lokality ze záznamu z API
export const toLocationValue = (record) => {
    if (!record) return null;

    // V poli location je celý název místa ("Praha - Žižkov (okr. Praha)"),
    // u starších záznamů tam je slug ("praha"), který převádí mapa.
    // city je jen obec bez části, proto jde až jako záloha.
    const label = record.location || record.city;
    if (!label) return null;

    return {
        label: LEGACY_LOCATION_LABELS[label] || label,
        city: record.city || null,
        postcode: record.postcode || null,
        latitude: record.latitude ?? null,
        longitude: record.longitude ?? null,
    };
};
